import { Component, inject, input, signal, type OnInit } from '@angular/core';
import { LoadingScreenComponent } from '@feh/shared-ui';
import { Store } from '@ngrx/store';
import type { SolarPanelsResultOverviewRendering } from '@feh/solar-panels-models';
import { componentViewModelSelector } from '@core/experience-editor-utils';
import {
  selectSolarPanelsResultOverviewViewModel,
  solarPanelsResultOverviewSubmitAction,
  solarPanelsShowPropositionMoreInfoModalAction,
  type SolarPanelsProductWithCalculations,
} from '@feh/solar-panels-store';
import { SolarPanelsResultOverviewUiComponent } from '@feh/solar-panels-ui';
import type { GenericModalProps } from '@legacy/common-ui-shared-interfaces';

import { initializeSolarPanelsFunnelComponent } from '../solar-panels-helpers';
import { mockSolarPanelsResultOverviewViewModel } from './solar-panels-result-overview-container.component.xp.mock';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';

@Component({
  selector: 'wl-solar-panels-result-overview-container',
  standalone: true,
  templateUrl: './solar-panels-result-overview-container.component.html',
  imports: [
    LoadingScreenComponent,
    SolarPanelsResultOverviewUiComponent,
    ContentSectionComponent,
  ],
})
export class SolarPanelsResultOverviewContainerComponent implements OnInit {
  readonly rendering = input.required<SolarPanelsResultOverviewRendering>();
  readonly context = input();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);

  readonly store = inject(Store);

  readonly viewModel = this.store.selectSignal(
    componentViewModelSelector(
      selectSolarPanelsResultOverviewViewModel,
      mockSolarPanelsResultOverviewViewModel
    )
  );

  readonly address = signal(
    `${this.viewModel().address?.street} ${this.viewModel().address?.housenumber}${
      this.viewModel().address?.housenumberaddition
        ? this.viewModel().address?.housenumberaddition
        : ''
    }, ${this.viewModel().address?.postalcode} ${this.viewModel().address?.city}`
  );

  loadingDuration = 3000;
  readonly showLoader = signal(true);

  readonly loadingScreenTitle = 'Mogelijkheden berekenen voor';
  readonly loaderItems = [
    { icon: 'solar-panel', text: 'Maximaal aantal zonnepanelen' },
    {
      icon: 'bolt-lightning',
      text: 'Aantal zonnepanelen nodig voor gebruik',
    },
    { icon: 'coins', text: 'Besparing berekenen' },
  ];

  ngOnInit() {
    this.store.dispatch(
      initializeSolarPanelsFunnelComponent(
        'resultOverview',
        this.rendering()?.fields.FunnelSettings
      )
    );
  }

  onSubmit() {
    this.store.dispatch(
      solarPanelsResultOverviewSubmitAction({
        product: this.viewModel().product as SolarPanelsProductWithCalculations,
      })
    );
  }

  onOpenPropositionMoreInfoModal(props: GenericModalProps) {
    this.store.dispatch(
      solarPanelsShowPropositionMoreInfoModalAction({ props })
    );
  }
}
